namespace $.$$ {
	const visible_floor = 0.01

	export class $easyreels_user_quota extends $.$easyreels_user_quota {
		override text() {
			return $easyreels_i18n_text('$easyreels_user_quota_text', {
				used: $easyreels_i18n_bytes(this.used_bytes()),
				limit: $easyreels_i18n_bytes(this.limit_bytes()),
			})
		}

		override ratio() {
			if (!this.limit_bytes() || !this.used_bytes()) return 0

			return Math.min(1, Math.max(visible_floor, this.used_bytes() / this.limit_bytes()))
		}
	}
}
